const preURL = '';//process.env.REACT_APP_API_URL; //موقع انتشار باید خالی بشه
//const rptURL =  'http://193.106.190.31';//'http://193.106.190.31';//http://80.210.21.25:81


const reportURL = 'http://80.210.21.25:81';//http://193.106.190.31';'http://5.160.100.75:81/'
export const getReportURL = () => {
    return `${reportURL}`;
}


//لاگین به سیستم
const login = preURL+`/Token/Login`;
export const getLoginURL = () => {
    return `${login}`;
}

//دریافت مقادیر پیش فرض ها
const defaultValues = preURL+`/Token/GetAllDefaultValues`;
export const getDefaultValuesURL = () => {
    return `${defaultValues}`;
}

//دریافت مرور حساب
const customerAccountReview = preURL+`/Sale/GetCustomerAccountReview`;
export const getCustomerAccountReviewURL = () => {
    return `${customerAccountReview}`;
}

//دریافت لیست فاکتور ها
const invoices = preURL+`/Sale/GetAllSaleDocs`;
export const getInvoicesURL = () => {
    return `${invoices}`;
}

//دریافت یک فاکتور
const invoice = preURL+`/Sale/GetSaleDoc`;
export const getInvoiceURL = () => {
    return `${invoice}`;
}

//دریافت لیست آمار ها
const statistics = preURL+`/Sale/GetCustomerSaleStatisticts`;
export const getStatisticsURL = () => {
    return `${statistics}`;
}



//دریافت لیست دریافت های نقد 
const receiptHeaders = preURL+`/Sale/GetAllReceiptHeaders`;
export const getReceiptHeadersURL = () => {
    return `${receiptHeaders}`;
}


//دریافت لیست دریافت های چک 
const receiptCheques = preURL+`/Sale/GetAllReceiptCheques`;
export const getReceiptChequesURL = () => {
    return `${receiptCheques}`;
}


//دریافت لیست دریافت های حواله 
const receiptDrafts = preURL+`/Sale/GetAllReceiptDrafts`;
export const getReceiptDraftsURL = () => {
    return `${receiptDrafts}`;
}


//دریافت لیست دریافت های کارت خوان 
const receiptPoses = preURL+`/Sale/GetReceiptPoses`;
export const getReceiptPosesURL = () => {
    return `${receiptPoses}`;
}


//درگاه پرداخت تست
const paymentTest = preURL+`/Adel/OrderPaymentTest`;
export const getPaymentTestURL = () => {
    return `${paymentTest}`;
}


//درگاه پرداخت
const payment = preURL+`/Sale/Payment`;
export const getPaymentURL = () => {
    return `${payment}`;
}

//درگاه پرداخت تکی سفارش
const orderPayment = preURL+`/Adel/OrderPayment`;
export const getOrderPaymentURL = () => {
    return `${orderPayment}`;
}

//درگاه پرداخت تکی سفارش
const orderPaymentConfirmation = preURL+`/Adel/OrderPaymentConfirmation`;
export const getOrderPaymentConfirmationURL = () => {

    return `${orderPaymentConfirmation}`;
}

//تایید پرداخت
const paymentConfirm = preURL+`/Sale/cbpMetllat`;
export const getPaymentConfirmURL = () => {
    return `${paymentConfirm}`;
}

//پرینت 
const PDFReportPage = process.env.REACT_APP_URL+`/Home/PDFReportPage`;
export const getPDFReportPageURL = () => {
    return `${PDFReportPage}`;
}


///ADEL
const cusomerExcludedFromRequiredTools = preURL+`/Adel/GetCusomerExcludedFromRequiredTools`;
export const getCusomerExcludedFromRequiredToolsURL = () => {
    return `${cusomerExcludedFromRequiredTools}`;
}

//دریافت لیست برندها 
const lensBrands = preURL+`/Adel/GetBrands`;
export const getLensBrandsURL = () => {

    return `${lensBrands}`;
}

const stlensTypes = preURL+`/Adel/GetSTLensTypesByBrand`;
export const getSTLensTypesURL = () => {

    return `${stlensTypes}`;
}

const stlensIndexes = preURL+`/Adel/GetSTLensIndexesByLensType`;
export const getSTLensIndexURL = () => {

    return `${stlensIndexes}`;
}

const stlensSphs = preURL+`/Adel/GetSTSphsByLensTypeAndLensIndex`;
export const getSTLensSphURL = () => {

    return `${stlensSphs}`;
}

const stlensCyls = preURL+`/Adel/GetSTCylsByLensTypeAndLensIndexAndSph`;
export const getSTLensCylURL = () => {

    return `${stlensCyls}`;
}

const stlensProducts = preURL+`/Adel/GetSTProductsByLensTypeAndLensIndexAndSphAndCyl`;
export const getSTProductsURL = () => {

    return `${stlensProducts}`;
}

const productByCode = preURL+`/Adel/GetProductByCode`;
export const getProductByCodeURL = () => {

    return `${productByCode}`;
}

const matrixQuantity = preURL+`/Adel/GetMatrixQuantity`;
export const getMatrixQuantityURL = () => {

    return `${matrixQuantity}`;
}

const stOrderPreview = preURL+`/Adel/GetSTOrderPreview`;
export const getSTOrderPreviewURL = () => {

    return `${stOrderPreview}`;
}

const submitSTOrder = preURL+`/Adel/SubmitSTOrder`;
export const getSubmitSTOrderURL = () => {

    return `${submitSTOrder}`;
}



const rxlensTypes = preURL+`/Adel/GetRXLensTypesByBrand`;
export const getRXLensTypesURL = () => {

    return `${rxlensTypes}`;
}
const rxlensDesignTypes = preURL+`/Adel/GetRXLensDesignTypesByBrandAndLensType`;
export const getRXLensDesignTypesURL = () => {

    return `${rxlensDesignTypes}`;
}
const rxlensIndexes = preURL+`/Adel/GetRXLensIndexesByBrandLensTypeAndDesignType`;
export const getRXLensIndexesURL = () => {

    return `${rxlensIndexes}`;
}
const rxlensMaterialTypes = preURL+`/Adel/GetRXMaterialTypesByBrandLensTypeAndLensIndex`;
export const getRXLensMaterialTypesURL = () => {

    return `${rxlensMaterialTypes}`;
}

const rxlensProducts = preURL+`/Adel/GetRXProductsByBrandLensTypeAndLensIndexAndMaterialType`;
export const getRXProductsURL = () => {

    return `${rxlensProducts}`;
}

const rxOrderPreview = preURL+`/Adel/GetRXOrderPreview`;
export const getRXOrderPreviewURL = () => {

    return `${rxOrderPreview}`;
}

const submitRXOrder = preURL+`/Adel/SubmitRXOrder`;
export const getSubmitRXOrderURL = () => {

    return `${submitRXOrder}`;
}

const rxCoatings = preURL+`/Adel/GetCoatings`;
export const getRXCoatingURL = () => {

    return `${rxCoatings}`;
}

const rxExtraServices = preURL+`/Adel/GetExtraServices`;
export const getRXExtraServicesURL = () => {

    return `${rxExtraServices}`;
}

const allOrders = preURL+`/Adel/GetAllOrders`;
export const getOrdersURL = () => {

    return `${allOrders}`;
}

const order = preURL+`/Adel/GetOrder`;
export const getOrderURL = () => {

    return `${order}`;
}


//دریافت گروه فروش  
const getSaleDepartment = preURL+`/Sale/GetMyOwnSaleDepartment`;
export const getSaleDepartmentURL = () => {

    return `${getSaleDepartment}`;
}

//ویرایش گروه فروش  
const updateSaleDepartment = preURL+`/Sale/GenerateSaleDepartment`;
export const updateSaleDepartmentURL = () => {

    return `${updateSaleDepartment}`;
}

//تغییر رمز عبور  
const updateUser = preURL+`/Sale/UpdateUser`;
export const updateUserURL = () => {

    return `${updateUser}`;
}


//تغییر وضعیت سفارش
const changeOrderState = preURL+`/Adel/ChangeOrdersState`;
export const getChangeOrderStateRL = () => {

    return `${changeOrderState}`;
}


//تنظیم پرداخت انلاین برای سفارش
const GenerateReceiptAndSetForOrders = preURL+`/Adel/GenerateReceiptAndSetForOrders`;
export const getGenerateReceiptAndSetForOrdersRL = () => {

    return `${GenerateReceiptAndSetForOrders}`;
}



//تنظیم پرداخت انلاین برای سفارش
const testRedirect = preURL+`/Adel/TestRedirect`;
export const getTestRedirectURL = () => {

    return `${testRedirect}`;
}
